module.exports = __webpack_public_path__ + "img/right_bottom_bg.5bf97e3f.png";